import { FC } from "react";

import Image from "@/components/ui/Image/Image";

import { EditorialModuleImageProps } from "../Editorial2Col/EditorialModuleImage";

const TiledImageVertical: FC<EditorialModuleImageProps> = ({ entry }) => {
  return (
    <div className="col-span-1 grid grid-cols-1">
      <Image src={entry.image.url} width={100} height={200} className="w-full h-full rounded-lg aspect-2-1" alt={entry.image.title} />
    </div>
  );
};
export default TiledImageVertical;
